
import { Link } from 'react-router-dom'
import SecuritySection from './SecuritySection'

const Marketing = () => {
  return (
    <div>
      <section className="relative z-10 mx-auto grid w-full max-w-6xl items-center gap-10 px-6 pb-24 pt-12 md:grid-cols-2">
        <div className="reveal">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/70 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-slate-600">
            Zero config deploy
          </div>
          <h1 className="text-4xl font-semibold leading-tight tracking-tight md:text-5xl">
            Launch full-stack apps with one command
          </h1>
          <p className="mt-4 max-w-xl text-base text-slate-600 md:text-lg">
            Flynt is a CLI-first deployment platform by Inflynx. No Dockerfiles, no GCP account, just deploy.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/app"
              className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:translate-y-[-1px]"
            >
              Open dashboard
            </Link>
            <button className="inline-flex items-center justify-center rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-ink hover:border-slate-400">
              View CLI install
            </button>
          </div>
          <div className="mt-8 rounded-2xl border border-slate-200 bg-white/80 p-4 text-sm shadow-sm">
            <div className="text-xs uppercase tracking-widest text-slate-500">Terminal</div>
            <div className="mt-2 font-mono text-ink">
              $ inflynx deploy
            </div>
            <div className="mt-2 text-slate-500">Build, ship, and scale in minutes.</div>
          </div>
        </div>

        <div className="relative reveal">
          <div className="rounded-3xl border border-slate-200 bg-white/90 p-6 shadow-lg float-slow card-hover">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs uppercase tracking-widest text-slate-500">Live deployment</div>
                <div className="text-lg font-semibold">nova-portfolio</div>
              </div>
              <div className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700">
                Healthy
              </div>
            </div>
            <div className="mt-6 grid gap-4">
              <div className="flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-100 p-4">
                <div>
                  <div className="text-sm font-semibold">Build pipeline</div>
                  <div className="text-xs text-slate-500">Completed in 48s</div>
                </div>
                <div className="h-2 w-24 rounded-full bg-slate-200">
                  <div className="h-2 w-20 rounded-full bg-slate-900" />
                </div>
              </div>
              <div className="flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-100 p-4">
                <div>
                  <div className="text-sm font-semibold">Requests</div>
                  <div className="text-xs text-slate-500">1.2k last 24h</div>
                </div>
                <div className="text-sm font-semibold text-ink">+18%</div>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-100 p-4">
                <div className="text-sm font-semibold">Environment</div>
                <div className="mt-2 grid grid-cols-2 gap-2 text-xs text-slate-500">
                  <div>REGION: asia-south1</div>
                  <div>RUNTIME: nextjs</div>
                  <div>MEMORY: 512MB</div>
                  <div>INSTANCES: 0-3</div>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute -bottom-8 -right-10 hidden h-28 w-28 rounded-3xl border border-slate-200 bg-white/90 p-4 shadow-lg md:block">
            <div className="text-xs uppercase tracking-widest text-slate-500">Latency</div>
            <div className="mt-2 text-2xl font-semibold">84ms</div>
            <div className="text-xs text-slate-500">avg global</div>
          </div>
        </div>
      </section>

      {/* Security & Trust Section */}
      <SecuritySection />

      <section className="border-t border-slate-200 bg-white/70">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-6 px-6 py-12 text-center md:flex-row md:justify-between md:text-left">
          <div>
            <h3 className="text-2xl font-semibold">Deploy your next idea in minutes</h3>
            <p className="mt-2 text-sm text-slate-600">Skip setup. Start shipping. Keep control.</p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <button className="rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white">
              Install CLI
            </button>
            <Link to="/app" className="rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-ink">
              Explore dashboard
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Marketing
